import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "border rounded p-3 mb-2 h-100" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = { class: "form-group mb-0" }
const _hoisted_5 = {
  key: 0,
  class: "col-6 text-end"
}
const _hoisted_6 = { class: "form-group mb-0" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "fa fa-calendar" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "row my-3" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "to-upper" }
const _hoisted_14 = {
  key: 0,
  class: "green-text"
}
const _hoisted_15 = {
  key: 1,
  class: "yellow-text"
}
const _hoisted_16 = {
  key: 2,
  class: "yellow-text"
}
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "row my-3" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "text-danger" }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  key: 2,
  class: "text-end my-2"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("span", { class: "small-round-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToDoMembersList = _resolveComponent("ToDoMembersList")

  return (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tasks, (task, taskIndex) => {
    return (_openBlock(), _createBlock("div", {
      class: "col-md-4 mb-2",
      key: `existing${taskIndex}`
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _withDirectives(_createVNode("input", {
                type: "checkbox",
                id: `checkbox${taskIndex}`,
                name: `checkbox${taskIndex}`,
                disabled: task.isCheckedDisabled,
                "onUpdate:modelValue": ($event: any) => (task.isChecked = $event)
              }, null, 8, ["id", "name", "disabled", "onUpdate:modelValue"]), [
                [_vModelCheckbox, task.isChecked]
              ])
            ])
          ]),
          (_ctx.isActive(task.role_id, task.permissions, 'edit_task'))
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  (!task.edit_start_date && !task.edit_start_date)
                    ? (_openBlock(), _createBlock("a", {
                        key: 0,
                        "data-toggle": "modal",
                        title: "Edit",
                        class: "btn default-btn btn-sm",
                        onClick: ($event: any) => (_ctx.showUpdateTaskModal(task))
                      }, [
                        _hoisted_7,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('add_date')), 1)
                      ], 8, ["onClick"]))
                    : (_openBlock(), _createBlock("a", {
                        key: 1,
                        "data-toggle": "modal",
                        title: "Edit",
                        class: "btn default-btn btn-sm",
                        onClick: ($event: any) => (_ctx.showUpdateTaskModal(task))
                      }, [
                        _hoisted_8,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                      ], 8, ["onClick"]))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_9,
        _createVNode("p", null, [
          _createVNode("strong", null, _toDisplayString(_ctx.$t('name_of_task')), 1)
        ]),
        (task.name)
          ? (_openBlock(), _createBlock("p", _hoisted_10, _toDisplayString(task.name), 1))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _createVNode("p", null, [
              _createVNode("strong", _hoisted_13, _toDisplayString(_ctx.$t('priority')), 1)
            ]),
            (task.priority_id === 3 || task.priority_id === '3')
              ? (_openBlock(), _createBlock("span", _hoisted_14, _toDisplayString(_ctx.$t('high')), 1))
              : (task.priority_id === 2 || task.priority_id === '2')
                ? (_openBlock(), _createBlock("span", _hoisted_15, _toDisplayString(_ctx.$t('medium')), 1))
                : _createCommentVNode("", true),
            (task.priority_id === 1 || task.priority_id === '1')
              ? (_openBlock(), _createBlock("span", _hoisted_16, _toDisplayString(_ctx.$t('low')), 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_17, [
            _createVNode("p", null, [
              _createVNode("strong", null, _toDisplayString(_ctx.$t('estimated_budget')), 1)
            ]),
            (task.edit_budget)
              ? (_openBlock(), _createBlock("p", _hoisted_18, _toDisplayString(task.edit_budget), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_19, [
          _createVNode("div", _hoisted_20, [
            _createVNode("p", null, [
              _createVNode("strong", null, _toDisplayString(_ctx.$t('start_date')), 1)
            ]),
            (task.edit_start_date)
              ? (_openBlock(), _createBlock("p", _hoisted_21, _toDisplayString(task.edit_start_date), 1))
              : (_openBlock(), _createBlock("p", _hoisted_22, "-"))
          ]),
          _createVNode("div", _hoisted_23, [
            _createVNode("p", null, [
              _createVNode("strong", null, _toDisplayString(_ctx.$t('end_date')), 1)
            ]),
            (task.edit_end_date)
              ? (_openBlock(), _createBlock("p", _hoisted_24, [
                  _createVNode("span", _hoisted_25, _toDisplayString(task.edit_end_date), 1)
                ]))
              : (_openBlock(), _createBlock("p", _hoisted_26, "-"))
          ])
        ]),
        (task.allMembers && task.allMembers.length)
          ? (_openBlock(), _createBlock(_component_ToDoMembersList, {
              key: 1,
              projectMembers: task.allMembers
            }, null, 8, ["projectMembers"]))
          : _createCommentVNode("", true),
        (_ctx.isActive(task.role_id, task.permissions, 'add_member_to_task'))
          ? (_openBlock(), _createBlock("div", _hoisted_27, [
              (!task.isCheckedDisabled)
                ? (_openBlock(), _createBlock("a", {
                    key: 0,
                    class: "d-block create-url",
                    href: "javascript:void(0)",
                    "data-toggle": "modal",
                    onClick: ($event: any) => (_ctx.addMemberToTask(task))
                  }, [
                    _hoisted_28,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('add_member')), 1)
                  ], 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]))
  }), 128))
}